import { html, ref, when, repeat } from '@microsoft/fast-element';
import { sync } from '@genesislcap/foundation-utils';
import type { ConsultantTab } from './consultant-reports';

export const ConsultantTabTemplate = html<ConsultantTab>`
  <div class="form-control required">
    <label>Independent Engineering Report</label>
    <zero-select
      ${ref('independentEngReport')}
      :value=${sync((x) => x.independentEngReportValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Energy Resource Study</label>
    <zero-select
      ${ref('energyResourceStudy')}
      :value=${sync((x) => x.energyResourceStudyValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Transmission/Congestion Study</label>
    <zero-select
      ${ref('transmissionStudy')}
      :value=${sync((x) => x.transmissionStudyValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Insurance Consultant Report</label>
    <zero-select
      ${ref('insuranceConsultantReport')}
      :value=${sync((x) => x.insuranceConsultantReportValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
`;
